import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AppConfig } from '@mkp/shared/util-app-config';
import { selectIsJoinAccount } from '@mkp/account/state';
import { Store } from '@ngrx/store';
import { selectIsBoUser } from '@mkp/user/state-logged-in/selectors';
import { combineLatest, filter, map, take } from 'rxjs';

export const isJoinAccountGuard = () => {
  const store = inject(Store);
  const router = inject(Router);

  return combineLatest([store.select(selectIsBoUser), store.select(selectIsJoinAccount)]).pipe(
    filter(
      ([isBoUser, isJoinAccount]) =>
        (isBoUser !== undefined || isBoUser !== null) && isJoinAccount !== undefined
    ),
    map(([isBoUser, isJoinAccount]) =>
      isBoUser && isJoinAccount ? router.parseUrl(AppConfig.routes.error404) : true
    ),
    take(1)
  );
};
